<template>
  <div>
    <div class="owner_title">金主书籍信息</div>
    <!-- 筛选 -->
    <div class="book_btn_box">
      <div>
        <div class="book_btn" @click="stopCooperation()">
          <i class="info_icon iconfont icon-tingzhi"></i>
          停止合作
        </div>
      </div>
      <div class="task_filtrate" @click="show_filter_form()">
        <i class="iconfont icon-shaixuan1"></i>
        <span>筛选</span>
      </div>
    </div>

    <!-- 筛选表单 -->
    <div class="filter_form" v-show="isFilterForm">
      <el-form
        ref="filter_form"
        :model="filter_form"
        :inline="true"
        class="demo-form-inline"
        label-width="100px"
      >
        <el-form-item label="金主昵称" prop="connection_name">
          <el-input v-model="filter_form.connection_name"></el-input>
        </el-form-item>
        <el-form-item label="书名" prop="connectionessay_name">
          <el-input v-model="filter_form.connectionessay_name"></el-input>
        </el-form-item>
        <el-form-item label="写手编辑" prop="writeradmin_name">
          <el-input v-model="filter_form.writeradmin_name"></el-input>
        </el-form-item>
        <el-form-item label="任务状态">
          <el-select v-model="filter_form.is_task" placeholder="任务状态">
            <el-option label="全部" value=""></el-option>
            <el-option label="已停止" value="-1"></el-option>
            <el-option label="进行中" value="1"></el-option>
            <el-option label="已完结" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日周结">
          <el-select v-model="filter_form.settlement_type" placeholder="日周结">
            <el-option label="全部" value=""></el-option>
            <el-option label="日结" value="1"></el-option>
            <el-option label="周结" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="最后录入时间">
          <el-date-picker
            v-model="filter_form.updatetime"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="goSearch"
          >搜索</el-button
        >
      </el-form>
    </div>

    <div class="task_box">
      <!-- 表格数据 -->
      <el-table
        ref="multipleTable"
        :data="dataShow"
        height="550"
        border
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column type="index" label="序号" align="center" width="50">
        </el-table-column>
        <el-table-column
          prop="connection_name"
          align="center"
          label="金主昵称"
          sortable
          :width="equipmentType == 0 ? 220 : 110"
        >
        </el-table-column>
        <el-table-column
          prop="connectionessay_name"
          align="center"
          label="书名"
          sortable
          :width="equipmentType == 0 ? 250 : 90"
        >
        </el-table-column>
        <el-table-column
          prop="writeradmin_name"
          align="center"
          label="写手编辑"
          sortable
          :width="equipmentType == 0 ? 160 : 110"
        >
        </el-table-column>
        <el-table-column
          prop="actual_cost"
          align="center"
          label="金主给千字价格"
          sortable
          :width="equipmentType == 0 ? 150 : 145"
        >
        </el-table-column>
        <el-table-column
          prop="each_chapter_num"
          align="center"
          label="每章字数"
          sortable
          :width="equipmentType == 0 ? 120 : 110"
        >
        </el-table-column>
        <!-- <el-table-column
          label="金主标签"
          align="center"
          sortable
          :width="equipmentType == 0 ? 140 : 110"
        >
          <template slot-scope="scope">
            <el-tag
              :key="item"
              v-for="item in scope.row.connectionlabel_text"
              type="info"
              >{{ item }}</el-tag
            >
          </template>
        </el-table-column> -->
        <el-table-column
          prop="is_task"
          align="center"
          label="任务状态"
          sortable
          :width="equipmentType == 0 ? 110 : 110"
        >
          <!-- //任务状态  1=进行中,2=已完结,-1=已停止 -->
          <template slot-scope="scope">
            <el-tag
              :type="
                scope.row.is_task == '1'
                  ? ''
                  : scope.row.is_task == '2'
                  ? 'success'
                  : 'danger'
              "
            >
              <div
                class="tag_circle"
                :class="[
                  scope.row.is_task == '1'
                    ? 'tag_blue'
                    : scope.row.is_task == '2'
                    ? 'tag_green'
                    : 'tag_red'
                ]"
              ></div>
              {{
                scope.row.is_task == "1"
                  ? "进行中"
                  : scope.row.is_task == "2"
                  ? "已完结"
                  : "已停止"
              }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="settlement_type"
          align="center"
          label="日周结"
          sortable
          :width="equipmentType == 0 ? 120 : 90"
        >
          <!-- "settlement_type": 1,//日周结状态 1-日结 2-周结 -->
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.settlement_type == '1' ? 'warning' : 'success'"
            >
              {{ scope.row.settlement_type == "1" ? "日结" : "周结" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="上传记录"
          sortable
          :width="equipmentType == 0 ? 180 : 115"
        >
          <template slot-scope="scope">
            <div class="day_upload_record" @click="dayUpload(scope.row)">
              每日上传记录<i class="el-icon-caret-bottom"></i>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          prop="updatetime"
          align="center"
          label="最后录入时间"
          :width="equipmentType == 0 ? 200 : 180"
          sortable
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          property="c_remarks"
          label="备注"
          align="center"
          sortable
          width="250"
        >
        </el-table-column>
        <!-- //任务状态  1=进行中,2=已完结,-1=已停止 -->
        <el-table-column
          :fixed="equipmentType == 1 ? false : 'right'"
          label="操作"
          align="center"
          width="310"
        >
          <template slot-scope="scope">
            <div class="control_btn_box">
              <div @click="editBookInfo(scope.row)" class="task_btn">
                <i class="el-icon-edit-outline"></i>
                修改
              </div>

              <div
                @click="downloadFile(scope.row)"
                class="task_btn"
                :disable="isLock"
              >
                <i class="info_icon iconfont icon-xiazai"></i>
                下载文件
              </div>
              <div
                @click="checkFinish(scope.row)"
                :class="[
                  {
                    task_btn: scope.row.is_task == 1,
                    disabled_btn:
                      scope.row.is_task == -1 || scope.row.is_task == 2
                  }
                ]"
              >
                <i
                  class="info_icon iconfont icon-cangpeitubiao_wanjiecaigoudanwanjiehuanhuodan"
                ></i>
                确认完结
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        v-show="equipmentType == 0 ? true : false"
        class="pagination_box"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
      <el-pagination
        v-show="equipmentType == 1 ? true : false"
        class="pagination_box"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="total"
      >
      </el-pagination>
      <!-- 每日上传记录弹窗 -->
      <el-dialog
        title="每日上传记录"
        :visible.sync="dayUploadDialogVisible"
        :width="equipmentType == 1 ? '90%' : '55%'"
      >
        <el-table :data="dataShowDialog" border>
          <el-table-column type="index" label="序号" align="center" width="50">
          </el-table-column>
          <el-table-column
            property="connectionessay_name"
            align="center"
            sortable
            label="书名"
            width="200"
          ></el-table-column>
          <el-table-column
            property="writeradmin_name"
            align="center"
            sortable
            label="写手编辑"
            width="150"
          ></el-table-column>
          <el-table-column
            property="start_chapters"
            align="center"
            sortable
            label="开始章节"
            width="120"
          ></el-table-column>
          <el-table-column
            property="end_chapters"
            align="center"
            sortable
            label="结束章节"
            width="120"
          ></el-table-column>
          <el-table-column
            property="word_number"
            align="center"
            sortable
            label="字数"
          ></el-table-column>
          <el-table-column
            property="record_time"
            align="center"
            sortable
            width="110"
            label="上传时间"
          ></el-table-column>
          <el-table-column align="center" sortable label="上传文件" width="120">
            <template slot-scope="scope">
              <div
                @click="downloadFileDialog(scope.row)"
                class="task_btn"
                :disable="isLockDialog"
              >
                <i class="info_icon iconfont icon-xiazai"></i>
                下载文件
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          v-show="equipmentType == 0 ? true : false"
          @size-change="handleSizeChangeaDialog"
          @current-change="handleCurrentChangeaDialog"
          :current-page="currentPageDialog"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSizeDialog"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalDialog"
        >
        </el-pagination>
        <el-pagination
          v-show="equipmentType == 1 ? true : false"
          @size-change="handleSizeChangeaDialog"
          @current-change="handleCurrentChangeaDialog"
          :current-page="currentPageDialog"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSizeDialog"
          layout="total, prev, pager, next"
          :total="totalDialog"
        >
        </el-pagination>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import {
  connectionessay_list,
  confirm_completion,
  cease_cooperate,
  connectionrecord_list,
  connectionrecord_zip
} from "@/utils/owner";
let previousRouterName = "";
let filter_obj = "";
let cancel_tag = "";
export default {
  data() {
    return {
      baseUrl: this.$global.commonUrl, //路径
      ownerId: "", //所属金主部门id
      bookList: [], //书籍列表
      isFilterForm: true, //筛选表单
      selectIds: [], //多选id
      dataShow: [], // 当前页要显示的数据,//显示的金主列表数据
      totalPageData: [], // 分页数据(全部数据已经分好页)
      pageNum: 1, // 共几页
      pageSize: 100, // 每页显示数量
      currentPage: 1, // 当前显示页码
      total: 1, // 总共多少条数据
      // 筛选
      filter_form: {
        connection_name: "", //金主昵称
        connectionessay_name: "", //书名
        writeradmin_name: "", //写手编辑
        is_task: "", //任务状态 1=进行中,2=已完结,-1=已停止 默认空
        settlement_type: "", //日周接 1=日结,2=周结 ,默认空
        updatetime: "" //最后录入时间
      },
      dayUploadDialogVisible: false, //每日上传记录弹窗
      dataShowDialog: [], // 当前页要显示的数据,//显示的金主列表数据
      totalPageDataDialog: [], // 分页数据(全部数据已经分好页)
      pageNumDialog: 1, // 共几页
      pageSizeDialog: 10, // 每页显示数量
      currentPageDialog: 1, // 当前显示页码
      totalDialog: 1, // 总共多少条数据
      dayUploadData: [], //每日上传数据
      isLock: false, //按钮的点击次数
      isLockDialog: false, //弹窗下载点击次数
      select_time_data: "",
      time_filter: "", //时间筛选
      equipmentType: 0 //设备 0-pc端 1移动端
    };
  },
  beforeRouteEnter(to, from, next) {
    previousRouterName = from.path;
    cancel_tag = from.params.edit_id;
    if (from.path === "/ownerBookInfoEdit") {
      if (from.params.edit_id == 1) {
        filter_obj = JSON.stringify(from.params.filter);
      } else {
        filter_obj = JSON.stringify(from.params.filter);
      }
    }
    next();
  },
  created() {
    this.ownerId = JSON.parse(localStorage.getItem("userInfo")).id;
    if (this.$isMobile.isDeviceType()) {
      this.equipmentType = 1;
    } else {
      this.equipmentType = 0;
    }
    if (previousRouterName === "/ownerBookInfoEdit") {
      var obj_data = JSON.parse(filter_obj);
      let obj;
      if (cancel_tag == 1) {
        obj = {
          departmentuser_id: this.ownerId,
          ...obj_data
        };
      } else {
        if (obj_data.updatetime == "") {
          obj = {
            departmentuser_id: this.ownerId,
            ...obj_data
          };
        } else {
          var createTimeData =
            obj_data.updatetime[0] + " - " + obj_data.updatetime[1];
          this.filter_form = obj_data;
          obj = {
            departmentuser_id: this.ownerId,
            ...obj_data,
            updatetime: createTimeData
          };
        }
      }

      connectionessay_list(obj).then(res => {
        if (res.data.code == 1) {
          this.total = res.data.data.length;
          this.bookList = res.data.data;
          this.calcPageData();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    } else {
      this.getBookList();
    }
  },

  methods: {
    // 获取书籍列表
    getBookList() {
      var that = this;
      let obj = {
        departmentuser_id: that.ownerId
      };
      connectionessay_list(obj).then(res => {
        if (res.data.code == 1) {
          that.total = res.data.data.length;
          that.bookList = res.data.data;
          that.calcPageData();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 每日上传文件
    dayUpload(val) {
      var that = this;
      that.dayUploadDialogVisible = true;
      var obj = {
        departmentuser_id: that.ownerId,
        connectionessay_id: val.id,
        page: 1,
        page_index: 10
      };
      connectionrecord_list(obj).then(res => {
        if (res.data.code == 1) {
          that.totalDialog = res.data.data.length;
          that.dayUploadData = res.data.data;
          that.calcPageDataDialog();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 每日上传文件的下载
    downloadFileDialog(val) {
      var that = this;
      if (that.isLockDialog == true) {
        this.$message.error("请勿频繁点击！");
        setTimeout(() => {
          this.isLockDialog = false;
        }, 3000);
      } else {
        if (that.equipmentType == 0) {
          // pc端
          var url = val.connection_files;
          var file_name = val.filename;
          console.log(url);
          if (url == "") {
            this.$message.error("暂无可下载文件");
          } else {
            var suffix = url.substring(url.lastIndexOf(".")); //zip

            if (suffix == "zip") {
              let link = document.createElement("a");
              link.style.display = "none";
              link.href = url;
              link.setAttribute("download", file_name);
              document.body.appendChild(link);
              link.click();
            } else {
              const x = new window.XMLHttpRequest();
              x.open("GET", url, true);
              x.responseType = "blob";
              x.onload = () => {
                const a_url = window.URL.createObjectURL(x.response);
                const a = document.createElement("a");
                a.href = a_url;
                a.download = file_name;
                a.click();
              };
              x.send();
            }
          }
          this.isLockDialog = true;
        } else {
          // 移动端
          var url = val.xurl;
          var file_name = val.filename;
          if (url == "") {
            this.$message.error("暂无可下载文件");
          } else {
            var suffix = url.substring(url.lastIndexOf(".")); //zip
            if (suffix == "zip") {
              let link = document.createElement("a");
              link.style.display = "none";
              link.href = url;
              link.setAttribute("download", file_name);
              document.body.appendChild(link);
              link.click();
            } else {
              let link_doc = document.createElement("a");
              link_doc.style.display = "none";
              link_doc.href = url;
              link_doc.target = "_blank";
              link_doc.setAttribute("download", file_name);
              document.body.appendChild(link_doc);
              link_doc.click();
            }
          }
          this.isLockDialog = true;
        }
      }
    },
    //修改书籍信息
    editBookInfo(val) {
      var that = this;
      let data = JSON.stringify(val);
      let filter = JSON.stringify(this.filter_form);
      // localStorage.setItem("filter", filter);
      that.$router.push(
        "/ownerBookInfoEdit?data=" + data + "&filter=" + filter
      );
    },
    // 筛选
    goSearch(val) {
      var that = this;
      var date1, date2;
      that.select_time_data = that.filter_form.updatetime;
      date1 = that.select_time_data[0];
      date2 = that.select_time_data[1];
      if (val == 0) {
        var time1, time2;
        time1 = that.select_time_data[0];
        time2 = that.select_time_data[1];
        that.time_filter = time1 + " - " + time2;
        that.filter_form.updatetime = that.time_filter;
        console.log("刷新", that.select_time_data);
      } else {
        console.log("第一次进入页面");
        if (date1 == undefined && date2 == undefined) {
          that.time_filter = "";
        } else {
          that.time_filter = date1 + " - " + date2;
        }
        console.log("that.time_filter", that.time_filter);
        that.filter_form.updatetime = that.time_filter;
      }

      let obj = {
        departmentuser_id: that.ownerId,
        page: 1,
        page_index: 10,
        ...that.filter_form
      };

      connectionessay_list(obj).then(res => {
        if (res.data.code == 1) {
          that.total = res.data.data.length;
          that.bookList = res.data.data;
          that.calcPageData();
          that.filter_form.updatetime = that.select_time_data;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 多选
    handleSelectionChange(val) {
      var that = this;
      var select_arr = [];
      val.forEach(element => {
        select_arr.push(element.id);
      });
      that.selectIds = select_arr;
    },
    // 确认完结
    checkFinish(val) {
      var that = this;
      let obj = {
        departmentuser_id: that.ownerId,
        connectionessay_id: val.id
      };
      confirm_completion(obj).then(res => {
        if (res.data.code == 1) {
          // that.getBookList();
          that.goSearch();
          that.$message.success(res.data.msg);
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    //停止合作
    stopCooperation(val) {
      var that = this;
      var connectionessay_ids;
      if (that.selectIds.length == 0) {
        connectionessay_ids = val.id;
      } else {
        connectionessay_ids = that.selectIds.join(",");
      }
      let obj = {
        departmentuser_id: that.ownerId,
        connectionessay_ids: connectionessay_ids
      };
      cease_cooperate(obj).then(res => {
        if (res.data.code == 1) {
          that.goSearch();
          // that.getBookList();
          that.$message.success(res.data.msg);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //下载文件
    downloadFile(val) {
      var that = this;
      if (that.isLock == true) {
        this.$message.error("请勿频繁点击！");
        setTimeout(() => {
          this.isLock = false;
          console.log(this.isLock);
        }, 5000);
      } else {
        let obj = {
          departmentuser_id: that.ownerId,
          connectionessay_id: val.id
        };
        connectionrecord_zip(obj).then(res => {
          if (res.data.code == 1) {
            console.log("书籍信息", res);
            let file_name = res.data.data.title;
            let url = res.data.data.url;
            let xurl = res.data.data.xurl;
            var suffix = url.substring(url.lastIndexOf(".")); //zip]

            if (suffix == "zip") {
              let link = document.createElement("a");
              link.style.display = "none";
              link.href = url;
              link.setAttribute("download", file_name);
              document.body.appendChild(link);
              link.click();
              URL.revokeObjectURL(link.href); // 释放URL 对象
              document.body.removeChild(link);
            } else {
              if (that.equipmentType == 0) {
                // pc端
                const xhr = new XMLHttpRequest();
                xhr.open("GET", url, true); // url 文件的完整地址 http:XXX
                xhr.responseType = "blob";
                xhr.onload = function() {
                  if (xhr.status === 200) {
                    const res = xhr.response;
                    console.log("url", url);
                    const link = document.createElement("a");
                    link.style.display = "none";
                    const url = window.URL.createObjectURL(res);
                    link.href = url;
                    link.setAttribute("download", file_name);
                    document.body.appendChild(link);
                    link.click();
                    window.URL.revokeObjectURL(link.href);
                    document.body.removeChild(link);
                  }
                };
                xhr.send();
              } else {
                // 移动端
                let link = document.createElement("a");
                link.style.display = "none";
                link.href = xurl;
                link.setAttribute("download", file_name);
                document.body.appendChild(link);
                console.log("移动端", link);
                link.click();
                URL.revokeObjectURL(link.href); // 释放URL 对象
                document.body.removeChild(link);
              }
            }
            that.$message.success(res.data.msg);
          } else {
            this.$message.error(res.data.msg);
          }
        });
        this.isLock = true;
      }
    },
    // 打开筛选表单
    show_filter_form() {
      var that = this;
      that.isFilterForm = !that.isFilterForm;
    },
    // 关闭弹窗触发
    cancelDialog() {
      this.goSearch(0);
    },
    // 计算页数的方法
    calcPageData() {
      if (this.bookList.length > 1) {
        this.pageNum = Math.ceil(this.bookList.length / this.pageSize) || 1;
      }
      for (let i = 0; i < this.pageNum; i++) {
        this.totalPageData[i] = this.bookList.slice(
          this.pageSize * i,
          this.pageSize * (i + 1)
        );
      }

      this.dataShow = this.totalPageData[this.currentPage - 1];
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.calcPageData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.dataShow = this.totalPageData[val - 1];
    },
    calcPageDataDialog() {
      if (this.dayUploadData.length > 1) {
        this.pageNumDialog =
          Math.ceil(this.dayUploadData.length / this.pageSizeDialog) || 1;
      }
      for (let i = 0; i < this.pageNumDialog; i++) {
        this.totalPageDataDialog[i] = this.dayUploadData.slice(
          this.pageSizeDialog * i,
          this.pageSizeDialog * (i + 1)
        );
      }

      this.dataShowDialog = this.totalPageDataDialog[
        this.currentPageDialog - 1
      ];
    },
    handleSizeChangeaDialog(val) {
      this.pageSizeDialog = val;
      this.calcPageDataDialog();
    },
    handleCurrentChangeaDialog(val) {
      this.currentPageDialog = val;
      this.dataShowDialog = this.totalPageDataDialog[val - 1];
    }
  }
};
</script>
<style scoped>
.el-main {
  margin: 0px;
  padding: 0px;
  background: #f5f7fa;
}
.owner_title {
  font-size: 17px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #304265;
  background: #ffffff;
  padding: 15px;
  border: 1px solid #e4e9f1;
}

.task_btn {
  width: 90px;
  height: 20px;
  line-height: 20px;
  background: #e7f2ff;
  color: #157df8;
  border-radius: 10px;
  margin: 0px 5px;
  font-size: 12px;
}
.info_icon {
  font-size: 12px;
}
.task_filtrate {
  text-align: right;
  padding: 10px 15px 10px 15px;
}
.task_filtrate i {
  font-size: 14px;
}
.task_filtrate span {
  font-size: 14px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #8893a7;
}
.filter_form {
  /* width: 96%; */
  /* height: 100px; */
  background: #ffffff;
  margin: 0px 16px;
  padding: 15px;
}
.pagination_box {
  float: right;
  margin-top: 15px;
  margin-right: 15px;
}
.task_box {
  margin: 0px 15px;
}
.day_upload_record {
  font-size: 13px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #157df8;
}
.control_btn_box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.disabled_btn {
  cursor: not-allowed;
  width: 90px;
  height: 20px;
  line-height: 20px;
  background: #eeeeee;
  color: #8893a7;
  border-radius: 10px;
  margin: 0px 5px;
  font-size: 12px;
  /* pointer-events: none; */
}
.tag_circle {
  width: 5px;
  height: 5px;
  border-radius: 50%;

  margin-right: 5px;
}
.tag_red {
  background: #f56c6c;
}
.tag_blue {
  background: #409eff;
}
.tag_green {
  background: #67c23a;
}
.book_btn_box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 15px 15px 10px 15px;
}
.book_btn {
  width: 100px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #e7f2ff;
  border-radius: 4px;
  color: #157df8;
  font-size: 14px;
}
/* @media screen and (max-width: 750px) and (min-width: 375px) {
  .task_box {
    margin-bottom: 150px;
  }
} */
</style>



// WEBPACK FOOTER //
// src/view/owner/OwnerBookInfo.vue